import styled from "styled-components";

export const MapContainer = styled.div`
  position: relative;
  .setting-icon {
    position: absolute;
    right: 24px;
    top: 171px;
    z-index: 3;
    background: #fffffff2;
    box-shadow: 0px 4px 4px #00000040;
    border-radius: 6px;
    width: 34px;
    height: 34px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
  }
  .gm-fullscreen-control {
    display: none;
  }
  .gmnoprint {
    bottom: 24vh !important;
    .gm-style-mtc {
      button {
        font-size: 16px !important;
      }
    }
  }
  .gmnoprint.gm-bundled-control {
    top: 72px !important;
    right: 50px !important;
    .gmnoprint {
      box-shadow: 0px 4px 4px #00000040;
      border-radius: 6px;
      overflow: hidden;
      bottom: unset !important;
      > div {
        height: 70px !important;
        width: 37px !important;
        button {
          width: 37px !important;
          height: 35px !important;
          img {
            width: 12px !important;
            height: 12px !important;
          }
        }
      }
    }
  }
`;

export const FilterHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: absolute;
  right: 0;
  left: 0;
  z-index: 1;
  top: 20px;
  padding-right: 20px;
  .tags {
    color: #2d2424;
    font-size: 14px;
    height: 38px;
    /* background: #82dbcf; */
    box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
    border-radius: 6px;
    display: inline-flex;
    min-width: 60px;
    padding: 0 10px;
    align-items: center;
    justify-content: center;
    gap: 8px;
    border: none;
  }
`;

export const TagsWrapper = styled.div`
  display: inline-flex;
  justify-content: center;
  width: 100%;
  gap: 10px;
  border: none;
`;

export const TagsContainer = styled.div`
  display: flex;
  gap: 5px;
  align-items: center;
  padding: 22px 13px 18px;
  justify-content: center;
  button {
    display: flex;
    align-items: center;
    justify-content: center;
    border: 1px solid var(--border-color);
    border-radius: 6px;
    background-color: var(--input-background);
    flex: 1;
    min-height: 28px;
    &.active {
      border-color: var(--theme-background);
      color: var(--theme-text);
      background-color: var(--theme-background);
      svg {
        path {
          fill: #fff;
        }
      }
    }
  }
`;
export const SelectTags = styled.div`
  display: flex;
  gap: 11px;
  padding: 12px 10px;
  border-bottom: 1px solid var(--section-border-color);
  button {
    border: 1px solid var(--border-color);
    border-radius: 6px;
    font-size: 13px;
    line-height: 150.5%;
    font-weight: 400;
    color: var(--text-primary);
    text-transform: initial;
    font-family: "Roboto";
    background-color: var(--input-background);
    flex: 1;
    &.active {
      border-color: var(--theme-background);
      color: var(--theme-text);
      background-color: var(--theme-background);
    }
  }
`;

export const FilterContainer = styled.div``;
export const FilterWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 24px;
  align-items: center;
  &.trails-section {
    padding: 23px 0 23px 6px;
    border-top: 1px solid #cdcfd0;
    border-bottom: 1px solid #cdcfd0;
    margin-bottom: 0;
  }
  &.trails-section-2 {
    padding: 15px 0 15px 6px;
    border-top: 1px solid #cdcfd0;
    border-bottom: 0px solid #cdcfd0;
    margin-bottom: 0;
  }
  .MuiSwitch-root .MuiSwitch-switchBase {
    padding: 1px;
  }
  .MuiSwitch-root .MuiSwitch-switchBase.Mui-checked {
    color: #00a692;
    .MuiSwitch-thumb,
    + .MuiSwitch-track {
      background-color: #00a692;
    }
  }

  .MuiSwitch-root .MuiSwitch-thumb {
    background-color: #92acb7;
    border: 3px solid #f2f6fa;
    box-shadow: none;
    width: 20px;
    height: 20px;
  }
  .MuiSwitch-track {
    background: #92acb7;
    opacity: 1;
    height: 8px;
    width: 92%;
  }
  .trails-icon {
    max-width: 11.25px;
    height: 15px;
    width: 100%;
  }
  p {
    display: flex;
    font-family: "Roboto", "Helvetica", "Arial", sans-serif;
    font-size: 13px;
    font-weight: 400;
    color: #1d1d1d;
    gap: 9px;
    span {
      min-width: 19px;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
`;

export const SubSideNavWrapper = styled.div`
  overflow: auto;
  max-height: calc(100vh - 178px);
  position: relative;
  /* padding: 0 5px 0 20px; */
  min-width: 255px;
  .gmnoprint {
    right: 0;
    left: unset !important;
    top: unset !important;
    bottom: 17%;
  }
  @media (max-width: 850px) {
    max-height: calc(100vh - 60px);
  }
`;
export const SelectTagCar = styled.div`
  position: relative;
  &.map-car-section {
    position: unset;
  }
  &.fleet-find-car-section {
    top: 150px;
    position: absolute;
    width: 383px;
  }
  .inner-wrapper {
    overflow-y: auto;
    max-height: 100vh;
  }
  .close-icon-wrapper {
    display: flex;
    justify-content: flex-end;
  }
  &.edit-msg-window {
    position: absolute;
    left: calc(50% - 172px);
    min-height: 350px;
    width: calc(100% - 40px);
    max-width: 344px;
    .inner-wrapper {
      padding: 10px 20px;
      .box-heading {
        margin: 0 0 18px;
      }
    }
  }
  &.site-setup {
    padding: 0 13px 13px;
    .heading {
      font-size: 14px;
      line-height: 150.5%;
      font-weight: 600;
      color: var(--text-primary);
      padding: 11px 0;
    }
    .filter-btn {
      display: flex;
      align-items: center;
      justify-content: space-between;
      gap: 18px;
      button {
        border: 1px solid var(--border-color);
        border-radius: 6px;
        padding: 0;
        flex: 1;
        font-size: 13px;
        line-height: 150.5%;
        font-weight: 400;
        color: var(--text-primary);
        text-transform: initial;
        background-color: var(--input-background);
        min-height: 30px;
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 10px;
        &.selected {
          border-color: var(--theme-background);
          color: var(--theme-text);
          background-color: var(--theme-background);
        }
      }
    }
  }
  &.zoom {
    width: 530px;
    position: absolute;
    background: rgb(255, 255, 255);
  }
  &.history-tag-cars {
    .inner-wrapper {
      padding-top: 27px;
      position: relative;
    }
  }
  /* position: absolute;
  right: -278px;
  top: 78px; */
  .checkbox-wrapper {
    display: flex;
    align-items: center;
    -webkit-box-pack: end;
    -webkit-justify-content: flex-end;
    -ms-flex-pack: end;
    justify-content: flex-end;
    gap: 15px;
    .MuiFormControlLabel-label {
      font-size: 13px;
    }
  }
  .response-section {
    padding: 0 3px;
    p {
      font-weight: 700;
      font-size: 13px;
      line-height: 150.5%;
      font-family: "Roboto", "Helvetica", "Arial", sans-serif;
      margin-bottom: 10px;
    }
    .MuiFormControlLabel-label {
      font-size: 13px;
    }
  }
  .text-area {
    padding: 0 3px;
    textarea {
      background: var(--input-background);
      border: 1px solid var(--side-nav-btn-border-color);
      border-radius: 6px;
      height: 112px;
      resize: none;
      width: 100%;
      font-size: 13px;
      color: var(--text-primary);
      padding: 13px 15px;
    }
  }
  .action-wrapper {
    display: flex;
    align-items: center;
    gap: 5px;
    margin: 23px 0 15px;
    justify-content: center;
    button {
      font-size: 13px;
      line-height: 150.5%;
      height: 30px;
      padding: 0 20px;
      background: transparent;
      border: 1px solid #67543e;
      border-radius: 30px;
      white-space: nowrap;
      &.active {
        background: rgb(188, 155, 106);
        color: rgb(255, 255, 255);
        border-color: transparent;
      }
      &.disabled {
        color: rgba(0, 0, 0, 0.26);
      }
    }
    .reset-btn {
      text-decoration: underline;
      padding: 0 13px;
      border: none;
    }
  }
  .inner-wrapper {
    position: relative;
    overflow: auto;
    max-height: calc(100vh - 100px);
    padding-right: 5px;
    background: linear-gradient(180deg, #f3ede4 0%, #ffffff 100%);
    padding: 9px 7px;
    border-radius: 6px;
    width: 100%;
    z-index: 1;
    @media (max-width: 850px) {
      position: absolute;
      right: 0;
      width: 100%;
      bottom: 0;
      /* max-height: initial; */
    }
  }

  ::-webkit-scrollbar {
    width: 6px;
  }
  ::-webkit-scrollbar-track {
    box-shadow: inset 0 0 5px grey;
    border-radius: 10px;
  }
  ::-webkit-scrollbar-thumb {
    background: #787874;
    border-radius: 10px;
  }
  ::-webkit-scrollbar-thumb:hover {
    background: #787874;
  }

  .box-heading {
    border-bottom: 1px solid var(--section-border-color);
    /* margin: 27px 0; */
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 5px;
    h5 {
      font-weight: 600;
      font-size: 16px;
      line-height: 150.5%;
      font-family: "Roboto", "Helvetica", "Arial", sans-serif;
      border-bottom: 2px solid #000;
      display: inline-flex;
      padding: 0 5px 6px;
    }
    /* @media (max-width: 850px) {
      border-bottom: 1px solid #947550;
    } */
  }
  .filter {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 9px;

    > div {
      display: flex;
      align-items: center;
      gap: 10px;
      button {
        padding: 0;
        background: transparent;
        border: none;
      }
    }
    p {
      font-size: 14px;
      line-height: 150.5%;
      color: var(--text-primary);
    }
  }
  .filter-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 12px;
    padding: 0 5px;
    h3 {
      font-size: 16px;
      font-weight: 600;
      line-height: 150.5%;
      color: var(--text-primary);
      margin: 0;
    }
  }
  .filter-content {
    margin-bottom: 12px;
  }
  .white-filter {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: 10px;
    padding: 0 5px;
    margin-bottom: 12px;
    button {
      padding: 0;
      background: transparent;
      border: none;
      &.active.not-com {
        width: 31px;
        height: 30px;
        background-color: #bc9b6a;
        border-radius: 6px;
        display: flex;
        align-items: center;
        justify-content: center;
        border: 1px solid transparent;

      }
      &.not-com {
        width: 31px;
        height: 30px;
        background-color: #fff;
        border-radius: 6px;
        display: flex;
        align-items: center;
        justify-content: center;
        border: 1px solid #ccc;
      }
    }
  }
  .pace-battery-filters {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 10px;
    button, span {
      padding: 0;
      background: transparent;
      border: none;
      cursor: pointer;
    }
  }
  .search-wrapper {
    position: relative;
    margin-bottom: 17px;
    input {
      background: var(--input-background);
      border: 1px solid var(--side-nav-btn-border-color);
      border-radius: 6px;
      color: var(--text-primary);
      height: 30px;
      width: 100%;
      padding: 0 42px 0 10px;
      font-size: 13px;
      line-height: 150.5%;
      font-family: "latoregular";
      ::-webkit-input-placeholder {
        color: var(--placeholder-color);
      }

      :-ms-input-placeholder {
        color: var(--placeholder-color);
      }

      ::placeholder {
        color: var(--placeholder-color);
      }
    }
    svg {
      position: absolute;
      top: 7.5px;
      right: 15.5px;
    }
  }
  .car-selection {
    .car-count {
      display: flex;
      align-items: center;
      justify-content: space-between;
      font-size: 13px;
      line-height: 150.5%;
      color: #ffffff;
      margin-bottom: 8px;
      > div {
        color: var(--text-primary);
        font-size: 14px;
        line-height: 150.5%;

        p {
          display: inline-flex;

          cursor: pointer;
        }
      }
    }
  }

  .car-number {
    display: flex;
    flex-wrap: wrap;
    gap: 7px;
    margin-bottom: 27px;
    max-height: 310px;
    overflow: auto;
    justify-content: center;
    color: var(--text-primary);

    > button {
      min-width: 33px;
      border: none;
      height: 32px;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      background: var(--input-background);
      border: 1px solid var(--btn-border);
      color: var(--text-primary);
      font-size: 14px;
      &.active {
        background: var(--theme-background);
        border-color: var(--btn-border);
        color: var(--theme-text);
      }
    }
  }
  @media (max-width: 850px) {
    &.fleet-find-car-section {
      .inner-wrapper {
        position: relative;
      }
    }
    &.fleet-car-msg {
      .inner-wrapper {
        position: relative;
      }
    }
    .car-number {
      padding-right: 5px;
    }
  }
`;
export const SelectTagCarStyle = styled.div`
  &.history-tag-cars {
    position: center;
  }
  .inner-wrapper {
    position: relative;
    overflow: auto;
    max-height: calc(100vh - 146px);
    padding-right: 5px;
    background-color: #000000cc;
    padding: 10px;
    border: 1px solid #707374;
    border-radius: 6px;
    width: 100%;
  }
  /* width: 270px; */
  border: 1px solid #707374;
  border-radius: 6px;

  &.white-theme {
    background-color: transparent;
    border: none;
    padding: 0 10px;
    .search-wrapper input {
      background: #ffffff;
      border: 1px solid #cdcfd0;
    }
    .car-selection {
      .car-count {
        color: #1d1d1d;
      }
    }
    .reset-section {
      button {
        color: #1d1d1d;
        border-color: #636f7c;
        white-space: normal;
      }
    }
  }

  ::-webkit-scrollbar {
    width: 6px;
  }
  ::-webkit-scrollbar-track {
    box-shadow: inset 0 0 5px grey;
    border-radius: 10px;
  }
  ::-webkit-scrollbar-thumb {
    background: #787874;
    border-radius: 10px;
  }
  ::-webkit-scrollbar-thumb:hover {
    background: #787874;
  }
  img.close-icon {
    position: absolute;
    right: 13px;
    top: 13px;
    cursor: pointer;
  }
  .box-heading {
    border-bottom: 1px solid var(--section-border-color);
    margin: 27px 0;
    display: flex;
    align-items: center;
    justify-content: space-between;
    h5 {
      color: #82dbcf;
      font-weight: 600;
      font-size: 16px;
      line-height: 150.5%;
      font-family: "Roboto", "Helvetica", "Arial", sans-serif;
      border-bottom: 2px solid #82dbcf;
      display: inline-flex;
      padding: 0 5px 6px;
    }
  }
  .filter {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 9px;

    > div {
      display: flex;
      align-items: center;
      gap: 10px;
      padding: 0 13px;
      button {
        padding: 0;
        background: transparent;
        border: none;
      }
    }
    p {
      color: #fff;
      font-size: 13px;
    }
  }
  .white-filter {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: 10px;
    padding: 0 5px;
    margin-bottom: 12px;
    button {
      padding: 0;
      background: transparent;
      border: none;
    }
  }
  .search-wrapper {
    position: relative;
    margin-bottom: 17px;
    input {
      background: #4c4a4a;
      border: 1px solid #707374;
      border-radius: 6px;
      height: 30px;
      width: 100%;
      padding: 0 42px 0 10px;
      font-size: 13px;
      ::-webkit-input-placeholder {
        color: #979797;
      }

      :-ms-input-placeholder {
        color: #979797;
      }

      ::placeholder {
        color: #979797;
      }
    }
    svg {
      position: absolute;
      top: 7.5px;
      right: 15.5px;
    }
  }
  .car-selection {
    .car-count {
      display: flex;
      align-items: center;
      justify-content: space-between;
      font-size: 13px;
      line-height: 150.5%;
      color: #ffffff;
      margin-bottom: 8px;
      > div {
      }
      span {
        font-family: "latobold";
      }
      p {
        text-decoration: underline;
        display: inline-flex;
        cursor: pointer;
      }
    }
  }

  .car-number {
    display: flex;
    flex-wrap: wrap;
    gap: 7px;
    margin-bottom: 27px;
    max-height: 310px;
    overflow: auto;
    justify-content: center;
    > button {
      min-width: 33px;
      border: none;
      height: 32px;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;

      background: #ffffff;
      border: 1px solid #c4c4c4;
      &.active {
        background: #82dbcf;
        border-color: #82dbcf;
      }
    }
  }
  .reset-section {
    display: flex;
    gap: 8px;
    align-items: center;
    button {
      font-size: 13px;
      line-height: 150.5%;
      padding: 5px 20px;
      color: #ffffff;
      border: 1px solid rgba(255, 255, 255, 0.9);
      border-radius: 30px;
      font-family: "Roboto", "Helvetica", "Arial", sans-serif;
      cursor: pointer;
      background-color: transparent;
    }
    .reset {
      font-size: 13px;
      line-height: 150.5%;
      text-decoration-line: underline;
      color: #ffffff;
      font-family: "Roboto", "Helvetica", "Arial", sans-serif;
      display: inline-flex;
      cursor: pointer;
      border: none;
      background: transparent;
      padding: 0;
      margin-left: 32px;
    }
  }
`;

export const SelectMessageCarStyle = styled.div`
  &.history-tag-cars {
    position: unset;
  }
  position: absolute;
  .inner-wrapper {
    position: relative;
    overflow: auto;
    max-height: calc(100vh - 125px);
    padding-right: 5px;
    background-color: #000000cc;
    padding: 10px;
    border: 1px solid #707374;
    border-radius: 6px;
    width: 100%;
  }
  /* width: 270px; */
  border: 1px solid #707374;
  border-radius: 6px;

  &.white-theme {
    background-color: transparent;
    border: none;
    padding: 0 10px;
    .search-wrapper input {
      background: #ffffff;
      border: 1px solid #cdcfd0;
    }
    .car-selection {
      .car-count {
        color: #1d1d1d;
      }
    }
    .reset-section {
      button {
        color: #1d1d1d;
        border-color: #636f7c;
        white-space: normal;
      }
    }
  }

  ::-webkit-scrollbar {
    width: 6px;
  }
  ::-webkit-scrollbar-track {
    box-shadow: inset 0 0 5px grey;
    border-radius: 10px;
  }
  ::-webkit-scrollbar-thumb {
    background: #787874;
    border-radius: 10px;
  }
  ::-webkit-scrollbar-thumb:hover {
    background: #787874;
  }

  .filter {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 9px;

    > div {
      display: flex;
      align-items: center;
      gap: 10px;
      button {
        padding: 0;
        background: transparent;
        border: none;
      }
    }
    p {
      color: #fff;
      font-size: 13px;
    }
  }
  .white-filter {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: 10px;
    padding: 0 5px;
    margin-bottom: 12px;
    button {
      padding: 0;
      background: transparent;
      border: none;
    }
  }
  .search-wrapper {
    position: relative;
    margin-bottom: 17px;
    input {
      background: #4c4a4a;
      border: 1px solid #707374;
      border-radius: 6px;
      height: 30px;
      width: 100%;
      padding: 0 42px 0 10px;
      font-size: 13px;
      ::-webkit-input-placeholder {
        color: #979797;
      }

      :-ms-input-placeholder {
        color: #979797;
      }

      ::placeholder {
        color: #979797;
      }
    }
    svg {
      position: absolute;
      top: 7.5px;
      right: 15.5px;
    }
  }
  .car-selection {
    .car-count {
      display: flex;
      align-items: center;
      justify-content: space-between;
      font-size: 13px;
      line-height: 150.5%;
      color: #ffffff;
      margin-bottom: 8px;
      > div {
      }
      span {
        font-family: "latobold";
      }
      p {
        text-decoration: underline;
        display: inline-flex;
        cursor: pointer;
      }
    }
  }

  .car-number {
    display: flex;
    flex-wrap: wrap;
    gap: 7px;
    margin-bottom: 27px;
    max-height: 310px;
    overflow: auto;
    justify-content: center;
    > button {
      min-width: 33px;
      border: none;
      height: 32px;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;

      background: #ffffff;
      border: 1px solid #c4c4c4;
      &.active {
        background: #82dbcf;
        border-color: #82dbcf;
      }
    }
  }
  .reset-section {
    display: flex;
    gap: 8px;
    align-items: center;
    button {
      font-size: 13px;
      line-height: 150.5%;
      padding: 5px 20px;
      color: #ffffff;
      border: 1px solid rgba(255, 255, 255, 0.9);
      border-radius: 30px;
      font-family: "Roboto", "Helvetica", "Arial", sans-serif;
      cursor: pointer;
      background-color: transparent;
    }
    .reset {
      font-size: 13px;
      line-height: 150.5%;
      text-decoration-line: underline;
      color: #ffffff;
      font-family: "Roboto", "Helvetica", "Arial", sans-serif;
      display: inline-flex;
      cursor: pointer;
      border: none;
      background: transparent;
      padding: 0;
      margin-left: 32px;
    }
  }
`;

export const MsgToCar = styled.div`
  .action-wrapper {
    display: flex;
    align-items: center;
    gap: 5px;
    justify-content: center;
    button {
      font-size: 12px;
      line-height: 150.5%;
      color: #1d1d1d;
      padding: 5px 10px;
      border: 1px solid #636f7c;
      border-radius: 30px;
      display: flex;
      align-items: center;
      min-width: 72px;
      min-height: 31px;
      gap: 5px;
      background-color: #fff;
      font-family: "latobold";
      text-transform: inherit;
      justify-content: center;

      &.active {
        background: #bc9b6a;
        color: #fff;
        border-color: transparent;
      }
      &.disabled {
        pointer-events: none;
        cursor: default;
        opacity: 0.65;
      }
    }
  }
  .add-msg {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: 7px;
    margin: 10px 0;
    padding: 0 3px;

    p {
      font-size: 13px;
      color: var(--text-primary);
      line-height: 150.5%;
    }
    img {
      cursor: pointer;
    }
  }
  .checkbox-wrapper {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    padding: 0 3px;
    .MuiFormControlLabel-label {
      font-size: 13px;
    }
    .MuiFormGroup-root {
      .MuiFormControlLabel-root {
        :last-child {
          margin: 0;
        }
      }
    }
  }
  .text-area {
    textarea {
      background: var(--input-background);
      border: 1px solid var(--side-nav-btn-border-color);
      border-radius: 6px;
      height: 112px;
      resize: none;
      width: 100%;
      font-size: 13px;
      color: var(--text-primary);
      padding: 13px 15px;
    }
  }
`;
export const PresetMessages = styled.div`
  position: absolute;
  right: -381px;
  top: 35%;
  background: #957650bd;
  z-index: 1;
  > div {
    border-radius: 6px;
    width: 377px;
    height: 269px;
  }

  .close-icon {
    cursor: pointer;
  }
  .presetMessagesContainer {
    display: flex;
    height: 100%;
    justify-content: center;
    align-items: center;
    color: var(--theme-text);
  }
  .heading-section {
    padding: 9px 15px;
    display: flex;
    justify-content: space-between;
    border-bottom: 1px solid #cdcfd0;
    align-items: center;
    position: relative;
    p {
      font-size: 16px;
      line-height: 150.5%;
      color: var(--theme-text);
      font-weight: 600;
    }
  }
  ul {
    padding: 0 8px;
    overflow: auto;
    height: calc(100% - 60px);

    margin: 5px 10px 5px 0;
    /* width */
    ::-webkit-scrollbar {
      width: 6px;
    }

    /* Track */
    ::-webkit-scrollbar-track {
      box-shadow: inset 0 0 5px grey;
      border-radius: 10px;
    }

    /* Handle */
    ::-webkit-scrollbar-thumb {
      background: var(--text-primary);
      border-radius: 10px;
    }

    /* Handle on hover */
    ::-webkit-scrollbar-thumb:hover {
      background: var(--text-primary);
    }
    li {
      font-size: 12px;
      color: #d7d7d7;
      display: flex;
      align-items: center;
      gap: 10px;
      position: relative;
      padding: 10px 10px 7px;
      border-bottom: 1px solid var(--section-border-color);
      :last-child {
        border: none;
      }
      ::before {
        content: "";
        width: 3px;
        background: #ffdb7d;
        height: calc(100% - 14px);
        display: inline-block;
        position: absolute;
        left: 0;
        top: 7px;
        bottom: 7px;
      }
      span {
        min-width: 27px;
        height: 27px;
        background: var(--text-primary);
        border-radius: 50%;
        display: inline-flex;
        align-items: center;
        justify-content: center;
      }
    }
  }
  @media (max-width: 1150px) {
    background: #957650;
    right: 0;
    left: 0;
    bottom: 0;
    top: unset;
    > div {
      width: 100%;
    }
  }
`;

export const HistoryWrapper = styled.div`
  max-height: calc(100vh - 112px);
  overflow-y: auto;
  overflow-x: hidden;

  .MuiFormControl-root {
    padding: 15px 7px;
    margin: 0;
    width: 100%;
    .MuiInputBase-root {
      border-radius: 6px;
      position: relative;
    }
    .MuiSelect-select {
      padding: 7.5px 14px;
      font-size: 14px;
    }
    .select-arrow {
      display: inline-flex;
      position: absolute;
      right: 0;
      width: 21px;
    }
  }
`;

export const ActionZoneWrapper = styled.div`
  min-width: 266px;
  position: relative;
  padding-top: 22px;
  .action-zone-sub-side-nav {
    background: transparent;
    border: none;
  }
`;
export const AddZoneActionWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 9px;
  position: relative;
  padding: 19px 8px;
  .MuiSelect-select {
    padding: 3.5px 14px;
    font-size: 13px;
    background-color: #fff;
  }

  button {
    font-size: 13px;
    line-height: 150.5%;
    padding: 5px 10px;
    border: 1px solid var(--btn-border);
    border-radius: 30px;
    display: flex;
    align-items: center;
    gap: 10px;
    background-color: var(--theme-text);
    flex: 1;
    justify-content: center;
    white-space: nowrap;
  }
  .active {
    background: var(--theme-background);
    color: var(--theme-text);
    border-color: var(--theme-background);
    svg {
      path {
        fill: var(--theme-text);
      }
    }
  }
`;

export const CarPathContainer = styled.div`
  width: 100%;
  .action-wrapper {
    display: flex;
    align-items: center;
    gap: 5px;
    margin: 23px 0 15px;
    justify-content: center;
    button {
      font-size: 13px;
      line-height: 150.5%;
      height: 30px;
      padding: 0 20px;
      background: transparent;
      border: 1px solid #67543e;
      border-radius: 30px;
      white-space: nowrap;
      color: inherit;
      font-weight: normal;
      text-transform: capitalize;
      .reset-btn {
        text-decoration: underline;
        padding: 0 13px;
        border: none;
      }
      &.active {
        background: #bc9b6a;
        color: #fff;
        border-color: transparent;
      }
      &.disabled {
        pointer-events: none;
        cursor: default;
        color: rgba(0, 0, 0, 0.26);
      }
    }
  }
  .MuiTypography-root {
    font-size: 13px;
    line-height: 15px;
    color: #000;
  }
  .page-heading {
    padding: 14px 14px 12px;
    font-size: 16px;
    line-height: 150.5%;
    border-bottom: 1px solid var(--section-border-color);
    color: #000;
    font-family: "Roboto", "Helvetica", "Arial", sans-serif;
    display: flex;
    font-weight: 500;
    align-items: center;
    img {
      margin-right: 10px;
    }
  }
  .disable-checkbox-section {
    display: flex;
    gap: 22px;
    padding: 17px 0;
    font-size: 13px;
    justify-content: center;
  }
  .heading {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 18px;
    font-size: 13px;

    h5 {
      line-height: 15px;
      color: #000;
      font-family: "Roboto", "Helvetica", "Arial", sans-serif;
    }
  }
  .circle-section {
    padding: 20px 22px;
    border-top: 1px solid var(--section-border-color);
    .circle-wrapper {
      display: flex;
      gap: 12px;
      flex-wrap: wrap;
      .active {
        background: var(--theme-background);
        color: var(--theme-text);
      }
      button {
        background: var(--theme-text);
        border: 1px solid var(--btn-border);
        font-size: 12px;
        height: 24px;
        width: 24px;
        border-radius: 50%;
        color: #176c81;
        padding: 0;
        font-family: "latomedium";
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }
  }
`;

export const SelectionHeading = styled.div`
  font-weight: 500;
  font-size: 14px;
  line-height: 150.5%;
  font-weight: 600;
  color: var(--text-primary);
  padding: 11px 13px;
`;
export const AZNote = styled.div` {
  border: 2px solid red;
  margin-left: 50px;
  margin-right: 50px;
  font-weight: bold;
  text-align: center;
}`;
export const CarTypeBtnWrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 10px;
  padding: 0 13px;
  margin-bottom: 11px;
  &.bdr {
    border-bottom: 1px solid var(--section-border-color);
  }
  button {
    border: 1px solid var(--border-color);
    border-radius: 6px;
    font-size: 13px;
    line-height: 150.5%;
    font-weight: 400;
    color: var(--text-primary);
    text-transform: initial;
    background-color: var(--input-background);
    min-height: 30px;
    display: flex;
    align-items: center;
    gap: 5px;
    white-space: nowrap;
    &.active {
      border-color: var(--theme-background);
      color: var(--theme-text);
      background-color: var(--theme-background);
      svg {
        path {
          fill: #fff;
        }
      }
    }
  }
`;

export const ConnectedStatesBtnWrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: 10px;
  padding: 0 13px;
  margin-bottom: 11px;
  border-bottom: 1px solid var(--section-border-color);
  button {
    border: 1px solid var(--border-color);
    border-radius: 6px;
    padding: 0 18px;
    font-size: 13px;
    line-height: 150.5%;
    font-weight: 400;
    color: var(--text-primary);
    text-transform: initial;
    background-color: var(--input-background);
    min-height: 30px;
    display: flex;
    align-items: center;
    gap: 10px;
    &.active {
      border-color: var(--theme-background);
      color: var(--theme-text);
      background-color: var(--theme-background);
    }
  }
`;
export const AddCar = styled.div`
  display: inline-flex;
  gap: 7px;
  align-items: center;
  cursor: pointer;
  font-size: 13px;
`;

export const SelectWrapper = styled.div`
  margin-bottom: 20px;
  .MuiFormControl-root {
    width: 100%;
    margin: 0;
  }
  .MuiInputBase-inputSizeSmall {
    padding-top: 3.5px;
    padding-bottom: 3.5px;
    background: #4c4a4a;
    color: #fff;
    font-size: 13px;
  }
  .MuiOutlinedInput-notchedOutline {
    border: 1px solid #707374;
  }
  .MuiSvgIcon-root {
    color: #d7d7d7;
  }
`;

export const ClickToDriveInputWrapper = styled.div`
  padding: 0 13px;
  input {
    border: 1px solid var(--border-color);
    border-radius: 6px;
    padding: 0 18px;
    font-size: 13px;
    line-height: 150.5%;
    font-weight: 400;
    color: var(--text-primary);
    text-transform: initial;
    background-color: var(--input-background);
    width: 100%;
    height: 30px;
  }
`;
